import { render, staticRenderFns } from "./campaign-import-teams-settings.vue?vue&type=template&id=1104e025&"
import script from "./campaign-import-teams-settings.vue?vue&type=script&lang=js&"
export * from "./campaign-import-teams-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports